import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import ExcludeCrawlers from './ExcludeCrawlers';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  isLoading: state.trackerSettings.global.isLoading,
  failed: state.trackerSettings.global.failed,
});

export const ConnectedExcludeCrawlers = connect(
  mapStateToProps, null,
)(ExcludeCrawlers);

export default withTranslation(['administration'])(ConnectedExcludeCrawlers as any);
